import React from 'react';
import { func, shape } from 'prop-types';
import Overlay from '@ynap/overlay';
import BEMHelper from '@ynap/bem-helper';
import DeliveryAndReturnsSkeleton from './DeliveryAndReturnsSkeleton/DeliveryAndReturnsSkeleton';
import { useStaticDeliveryInfo } from '@ynap/delivery-hook';
import { formatPrice } from '@ynap/intl-formatters';
import { SingleBadge } from '@ynap/badge';

const bem = new BEMHelper('DeliveryAndReturnsModal');

const ShippingDescripton = (props) => (
    <div data-testid="shippingDescription" className={bem('shipModeDescription')}>
        {props.children}
    </div>
);

ShippingDescripton.displayName = 'ShippingDescripton';

export const DeliveryAndReturnsModal = ({ closeModal, config, messages, locale }) => {
    const { error, responseData, isLoading } = useStaticDeliveryInfo();
    const { error: errorMessageObj, deliveryAndReturns, considered } = messages;
    const { urlCustomerReturns, country } = config;
    const loading = isLoading || responseData.length === 0;

    return (
        <Overlay className={bem()} data-testid="DeliveryAndReturnsModal" onClose={closeModal} title={deliveryAndReturns.title()}>
            <p className={bem('shipModesLabel')}>{deliveryAndReturns.shippingModesIntro()}</p>
            {loading && !error ? (
                <DeliveryAndReturnsSkeleton className={bem('shipModeItem')} />
            ) : error ? (
                <p className={bem('errorModalText')}>{errorMessageObj.unknownError()}</p>
            ) : (
                <ul>
                    {responseData.map(({ shipModeId, shipModeCode, shippingDescription, shippingCharge, shippingChargeCurrency }) => {
                        return (
                            <li className={bem('shipModeItem')} key={shipModeId}>
                                <span data-testid="shippingMethod" className={bem('shipModeTitle')}>
                                    {deliveryAndReturns.shippingMode({ shipModeCode })}
                                </span>
                                <span data-testid="shippingCharge" className={bem('shipModeCharge')}>
                                    {formatPrice(shippingCharge, shippingChargeCurrency, locale)}
                                </span>
                                <div data-testid="shippingDescription" className={bem('shipModeDescription')}>
                                    {shippingDescription.split('\\n').map((text, index) => (
                                        <p key={`${shipModeId}-${index}`}>{text.trim()}</p>
                                    ))}
                                </div>
                                {shipModeCode === 'STANDARD' ? (
                                    <div className={bem('consideredWrapper')}>
                                        <span className={bem('considered')}>
                                            <SingleBadge
                                                className={bem('consideredBadge')}
                                                considered={true}
                                                badge={{ label: 'consideredBadge', key: 'CONSIDERED_BADGE' }}
                                                translation={considered.badge()}
                                            />
                                        </span>
                                        <span className={bem('consideredMessage')}>{considered.consideredDelivery()}</span>
                                    </div>
                                ) : null}
                            </li>
                        );
                    })}
                </ul>
            )}
            <p data-testid="returnsInfo" className={bem('returnsLabel')}>
                {deliveryAndReturns.returnsInfo({ country })}
            </p>
            <a data-testid="returnsLink" className={bem('returnsFindOutMoreLink')} href={urlCustomerReturns}>
                {deliveryAndReturns.findOutMoreLink()}
            </a>
        </Overlay>
    );
};

DeliveryAndReturnsModal.propTypes = {
    messages: shape({
        deliveryAndReturns: shape({
            title: func.isRequired,
            shippingModesIntro: func.isRequired,
            shippingMode: func.isRequired,
            returnsInfo: func.isRequired,
            shippingChargeCurrency: func.isRequired,
        }),
        considered: shape({
            badge: func.isRequired,
            consideredDelivery: func.isRequired,
        }),
        error: shape({
            unknownError: func.isRequired,
        }),
    }),
    closeModal: func.isRequired,
};
